import { render } from "./retailGroupPopup.vue?vue&type=template&id=a2a8bbb6&scoped=true"
import script from "./retailGroupPopup.vue?vue&type=script&lang=js"
export * from "./retailGroupPopup.vue?vue&type=script&lang=js"

import "./retailGroupPopup.vue?vue&type=style&index=0&id=a2a8bbb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a8bbb6"]])

export default __exports__